import { render, staticRenderFns } from "./TextMessageChannel.vue?vue&type=template&id=22671497&scoped=true&lang=html"
import script from "./TextMessageChannel.vue?vue&type=script&lang=js"
export * from "./TextMessageChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22671497",
  null
  
)

export default component.exports